import ZoneIcon from "./icons/zone";
import LocationIcon from "./icons/location";
import AlternativeLocationIcon from "./icons/alternativeLocation";
import { COLORS } from "../../constants";

const markerIcons = {
  zone: {},
  location: {},
  alternativeLocation: {},
};

const icons = {
  zone: ZoneIcon,
  location: LocationIcon,
  alternativeLocation: AlternativeLocationIcon,
};

export const imageMaker = (color, type) => {
  return (
    "data:image/svg+xml;charset=utf-8;base64," +
    btoa(unescape(encodeURIComponent(icons[type](color))))
  );
};

COLORS.forEach((color) => {
  ["zone", "location", "alternativeLocation"].forEach((type) => {
    markerIcons[type][color] = imageMaker(`#${color}`, type);
  });
});

export default markerIcons;
